import {Component, ElementRef, Injector, ViewEncapsulation} from '@angular/core';
import {Message} from '../../models/message.model';
import {MessageType} from '../../constants/message-type.constant';
import {BasePageComponent} from '../../../base/components/base-page.component';
import {Observable} from 'rxjs';

declare var $: any;

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-message-viewer',
  templateUrl: './message-viewer.component.html',
  styleUrls: ['./message-viewer.component.scss'],
})
export class MessageViewerComponent extends BasePageComponent {
  MessageType = MessageType;

  message: Message;
  queue: any[] = [];

  viewerReference: ElementRef;

  showing = false;
  forDeveloperOnly: boolean = false;
  confirmPayload: Observable<any>;

  confirmationLoading: boolean;
  callbackError: boolean;

  constructor(injector: Injector) {
    super(injector);
    this.messageService.subscribe((m: Message | any) => {
      this.confirmPayload = null;
      this.message = m;
      this.showing = false;
      this.queue.push(m);
      this.next();
    });
  }

  /**
   * Questo metodo si occupa di visualizzare il messaggio
   */
  manageMessage(mex: Message | any) {
    console.log(mex);
    // se di tipo Message(nessun payload da confermare)
    if (this.message instanceof Message) {
      this.message = mex;
      this.confirmPayload = null;

      if (!this.viewerReference) {
        this.viewerReference = this.inizializeViewer();
      }
      if (!this.showing) {
        this.showViewer();
        this.showing = true;
      }
      mex.managed();
    }
    // se ha una callback da confermare
    else {
      this.message = mex.mex;
      this.confirmPayload = mex.callback;

      if (!this.viewerReference) {
        this.viewerReference = this.inizializeViewer();
      }
      if (!this.showing) {
        this.showViewer();
        this.showing = true;
      }
    }
  }

  onConfirmAction(payload: Observable<any>) {
    this.confirmationLoading = true;
    payload.subscribe(
      (res) => {
        this.confirmationLoading = false;
        this.callbackError = false;
        this.close();
      }, (error) => {
        this.confirmationLoading = false;
        this.callbackError = true;
      });
  }

  close(): void {
    this.hideViewer();
    this.showing = false;

    setTimeout(() => {
      this.next();
    }, 1000);
  }

  next() {
    if (!this.showing && this.queue.length > 0) {
      this.manageMessage(this.queue.shift());
    }
  }

  protected inizializeViewer(): ElementRef {
    if (!this.confirmPayload) {
      return $('.toast').toast({
        animation: true,
        autohide: true,
        delay: 3000
      });
    } else {
      return window['$']('#message-modal').modal({backdrop: 'static', show: false});
    }
  }

  showViewer() {
    // se c'è un payload da confermare apre una modale, sennò un toast'
    if (this.confirmPayload) {
      window['$']('div.modal.alert-modal').attr('aria-labelledby', 'message-modal-title');
      window['$']('#message-modal').modal('show');
    } else {
      $('.toast').toast('show');
    }
  }

  hideViewer() {
    window['$']('#message-modal').modal('hide');
    window['$']('div.modal').removeAttr('aria-labelledby');
  }

  getDefaultTitle(): string {
    switch (this.message.type) {
      case MessageType.ERROR_BLOCK:
      case MessageType.ERROR_MANAGED:
      case MessageType.ERROR_AUTHENTICATION:
        return 'MESSAGE.TITLE.ERROR';
      case MessageType.WARNING_MESSAGE:
        return 'MESSAGE.TITLE.WARNING';
      case MessageType.CONFIRM_MESSAGE:
        return 'MESSAGE.TITLE.SUCCESS';
      case MessageType.INFO_MESSAGE:
      default:
        return 'MESSAGE.TITLE.INFO';
    }
  }

  ngOnDestroyForChildren(): void {
  }

  ngOnInitForChildren(): void {
  }

  pageName(): string {
    return 'MessageViewerComponent';
  }
}
